import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Checkbox } from 'framework/checkbox';
import { parseArray, parseQuery } from 'utils/queries';

import { useFiltersContext } from 'components/overlays/context/FiltersContext';

import { EMPTY_ARRAY } from '../../../../constants';
import { AccordionFilter } from '../accordion-filter/AccordionFilter';

import { AccordionCheckboxesProps } from './types';

export const AccordionCheckboxes = <T extends { [key: string]: any }>({
  label = '',
  filter_key = '',
  value_key = '',
  id_key = '',
  options = EMPTY_ARRAY,
}: AccordionCheckboxesProps<T>) => {
  const { search } = useLocation();
  const [is_open, setOpen] = useState(false);
  const { filters, updateQueries, updateFilters } = useFiltersContext();

  useEffect(() => {
    const queries = parseQuery(search);

    if (filter_key) {
      const filter = parseArray(queries[filter_key]);
      updateFilters({ [filter_key]: filter });
      updateQueries({ [filter_key]: filter });
    }
  }, [search, filter_key, updateQueries, updateFilters]);

  const setToggle = useCallback((value: boolean) => setOpen(value), []);
  const ids: string[] = filters[filter_key] || [];

  return (
    <AccordionFilter label={label} count={ids.length} is_expanded={is_open} setToggle={setToggle}>
      {options.map((option) => {
        const value = option[value_key];
        const id = String(option[id_key] || 0);
        const checked = ids.includes(id);
        const updated = checked ? ids.filter((item) => item !== id) : [...ids, id];
        return (
          <Checkbox
            height="24px"
            onClick={() => {
              updateFilters({ [filter_key]: updated });
            }}
            right_label={value}
            checked={checked}
          />
        );
      })}
    </AccordionFilter>
  );
};
